/**
 * A chosen file's text, decoded as UTF-8 (`equipment-page-upload-columns`, R2).
 *
 * `Blob.text()` where the browser has it — every browser the viewer supports does (Safari 15 is the
 * floor) — and a `FileReader` otherwise. The fallback exists for the viewer's jest DOM, jsdom 16,
 * whose `Blob` has no `text()`; it reads the same bytes the same way.
 */
const readFileText = (file: Blob): Promise<string> => {
  if (typeof file.text === 'function') return file.text();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : '');
    reader.onerror = () => reject(reader.error ?? new Error('The file could not be read.'));
    reader.readAsText(file, 'utf-8');
  });
};

export default readFileText;
